module.exports = __webpack_public_path__ + "img/ic_my_jobs.5e975d99.svg";